"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const coffeescript_1 = require("coffeescript");
function build(cells) {
    const merged = cells
        .filter(isCodeCell)
        .map(code => code.value)
        .join('\n');
    try {
        const js = coffeescript_1.CoffeeScript.compile(merged);
        return js;
    }
    catch (error) {
        console.error(error);
        console.error(merged);
        return '';
    }
}
exports.build = build;
function isCodeCell(cell) {
    return cell.type === 'code';
}
exports.isCodeCell = isCodeCell;
